<div
  class="container"
  [ngClass]="{
    dirLtr:
      pageLoaded &&
      !loading &&
      _DataService.getUserData() &&
      _lang.direction == 'ltr'
  }"
>
  <!-- privacy tabs with login -->
  <div
    [ngClass]="{ 'page-container': true }"
    [ngStyle]="{
      display:
        activeLink === 'terms' ||
        activeLink === 'privacy' ||
        activeLink === 'about' ||
        activeLink === 'FAQ'
          ? 'block'
          : 'none'
    }"
    class="privacy-pages"
  >
    <a routerLink="/" class="brand">
      <figure>
        <img src="assets/images/logo.svg" />
      </figure>
    </a>
    <div
      class="privacy-pages-content"
      [ngClass]="{ dirLtr: _lang.direction == 'ltr' }"
    >
      <nav
        class="tabs"
        #tabs
        (mousedown)="mouseDown($event)"
        (mouseleave)="mouseleave()"
        (mouseup)="mouseup()"
        (mousemove)="mousemove($event)"
      >
        <a
          [routerLink]="'/pages/FAQ'"
          (click)="activeLink = 'FAQ'"
          [class.active]="activeLink == 'FAQ'"
          id="FAQ"
        >
          {{ "privacy-pages.FAQ" | translate }}
        </a>
        <a
          [routerLink]="'/pages/terms'"
          (click)="activeLink = 'terms'"
          [class.active]="activeLink == 'terms'"
          id="terms"
        >
          {{ "privacy-pages.TAC" | translate }}
        </a>
        <a
          [routerLink]="'/pages/privacy'"
          (click)="activeLink = 'privacy'"
          [class.active]="activeLink == 'privacy'"
          id="privacy"
        >
          {{ "privacy-pages.PP" | translate }}
        </a>
        <a
          [routerLink]="'/pages/about'"
          (click)="activeLink = 'about'"
          [class.active]="activeLink == 'about'"
          id="about"
        >
          {{ "privacy-pages.WAW" | translate }}
        </a>
      </nav>
      <div
        class="privacy-background"
        [ngClass]="{ faq: activeLink === 'FAQ' }"
        [ngStyle]="{
          display: pageLoaded && !loading ? 'block' : 'none'
        }"
      >
        <div
          [ngClass]="{ 'about-page': pageId === 'about' && screenWidth < 960 }"
          class="info"
          *ngIf="
            activeLink === 'terms' ||
            activeLink === 'privacy' ||
            activeLink === 'about'
          "
        >
          <h3>
            {{
              (activeLink === "terms"
                ? "privacy-pages.TAC"
                : activeLink === "privacy"
                ? "privacy-pages.PP"
                : ""
              ) | translate
            }}
          </h3>
          <p
            class="data-text"
            *ngIf="activeLink !== 'about' || screenWidth > 960"
            [innerHtml]="htmlData | matchUrl"
          ></p>
          <!-- <figure *ngIf="activeLink === 'about' && screenWidth < 960">
            <img src="assets/images/logo-about.png" />
          </figure> -->
          <p
            class="data-text"
            *ngIf="activeLink === 'about' && screenWidth < 960"
            [innerHtml]="htmlData | matchUrl"
          ></p>
        </div>
        <div *ngIf="activeLink === 'FAQ' && htmlData" class="info">
          <mat-accordion class="example-headers-align accordion-faq">
            <mat-expansion-panel
              hideToggle
              [id]="item.id"
              *ngFor="let item of htmlData"
            >
              <mat-expansion-panel-header (click)="toggle(item.id)">
                <mat-icon>{{
                  item.id == panelOpenStateID && panelOpenState
                    ? "remove"
                    : "add"
                }}</mat-icon>
                <mat-panel-title>
                  <!-- {{ "FAQ.protect-personal-ques" | translate }} -->
                  {{ item.question }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <p>
                {{ item.answer }}
              </p>
            </mat-expansion-panel>

            <mat-expansion-panel
              hideToggle
              [id]="item.id"
              *ngFor="let item of htmlData"
            >
              <mat-expansion-panel-header (click)="toggle(item.id)">
                <mat-icon>{{
                  item.id == panelOpenStateID && panelOpenState
                    ? "remove"
                    : "add"
                }}</mat-icon>
                <mat-panel-title>
                  <!-- {{ "FAQ.protect-personal-ques" | translate }} -->
                  {{ item.question }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <p>
                {{ item.answer }}
              </p>
            </mat-expansion-panel>

            <!-- <mat-expansion-panel hideToggle #panel2>
              <mat-expansion-panel-header>
                <mat-icon>{{ panel2.expanded ? "remove" : "add" }}</mat-icon>

                <mat-panel-title>
                  {{ "FAQ.how-use-ques" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <p>

              </p>
            </mat-expansion-panel>

            <mat-expansion-panel hideToggle #panel3>
              <mat-expansion-panel-header>
                <mat-icon>{{ panel3.expanded ? "remove" : "add" }}</mat-icon>

                <mat-panel-title>
                  {{ "FAQ.designate-host" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <p>
                هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد
                هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو
                العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها
                التطبيق.إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص
                العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي
                أخطاء لغوية، مولد النص العربى مفيد لمصممي المواقع على وجه
                الخصوص، حيث يحتاج العميل فى كثير من الأحيان أن يطلع على صورة
                حقيقية لتصميم الموقع.ومن هنا وجب على المصمم أن يضع نصوصا مؤقتة
                على التصميم ليظهر للعميل الشكل كاملاً،دور مولد النص العربى أن
                يوفر على المصمم عناء البحث عن نص بديل لا علاقة له بالموضوع الذى
                يتحدث عنه التصميم فيظهر بشكل لا يليق.هذا النص يمكن أن يتم تركيبه
                على أي تصميم دون مشكلة فلن يبدو وكأنه نص منسوخ، غير منظم، غير
                منسق، أو حتى غير مفهوم. لأنه مازال نصاً بديلاً ومؤقتاً.
              </p>
            </mat-expansion-panel> -->
          </mat-accordion>
        </div>

        <span
          class="technical"
          (click)="openZenDesk()"
          [ngClass]="{ dirLtr: _lang.direction == 'ltr' }"
        >
          <figure
            cdkScrollable
            #tooltip="matTooltip"
            [matTooltip]="'privacy-pages.Tech-Sup' | translate"
            matTooltipPosition="above"
          >
            <img
              src="../../../../assets/images/icons/headset_mic.svg"
              [alt]="'privacy-pages.Tech-Sup' | translate"
            />
          </figure>
        </span>
      </div>
      <div *ngIf="loading" class="page-container loader">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>

  <div *ngIf="!pageLoaded && !loading" class="page-container">
    <h1>
      {{ "page-not-found" | translate }}
    </h1>
  </div>

  <!-- <div *ngIf="loading" class="page-container">
    <mat-spinner></mat-spinner>
  </div> -->
</div>
